var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"imageBlock no-gutters"},[_c('transition',{attrs:{"appear":"","name":"from-below"}},[_c('v-col',{attrs:{"cols":"12","sm":_vm.full ? 12 : 6}},[_c('img',{attrs:{"src":_vm.url}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }